export enum OAuthClientType {
    Public = 0,
    Confidential = 1
}

export interface Client {
    id: string;
    clientName: string;
    clientId?: string;
    clientSecret?: string;
    clientType?: OAuthClientType;
    createdAt: string;
}
